import { FiTaskV2HelperService } from '../../task-v2/fi-task-v2-helper.service';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { ITaskV2 } from '../../task-v2/fi-task-v2';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiTaskType } from '../../task-v2/fi-task-v2-enums';
import { FiTasksViewMode } from '@fi-shared/fi-task-shared/fi-task-enums';
import { FiTaskSyncService } from '@fi-shared/fi-task-shared/fi-task-sync-service';
import { Subject } from 'rxjs';
import { FiTaskStatusType } from '@fi-app/task-v2/fi-task-v2-enums';

@Component({
    selector: 'fi-task-v2-list-item',
    templateUrl: './fi-task-v2-list-item.component.html',
    styleUrl: './fi-task-v2-list-item.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-task-v2-list-item' },
    standalone: false,
})
export class FiTaskV2ListItemComponent implements OnInit, OnDestroy {
    @Input({ required: true }) task: ITaskV2;
    @Input({ required: true }) viewMode: FiTasksViewMode;

    constructor(
        private fiStateService: FiStateService,
        private fiTaskV2HelperService: FiTaskV2HelperService,
        private fiTaskSyncService: FiTaskSyncService,
        private cdr: ChangeDetectorRef,
    ) {}

    public ngOnInit(): void {
        this.subscribeToSyncTasks();
    }

    private subscribeToSyncTasks() {
        this.fiTaskSyncService.subscribeToTaskUpdatedBySync(this.task.Id, this.ngOnDestroy$, (updatedTask) => {
            this.fiTaskSyncService.updateTaskProps(this.task, updatedTask);
            this.cdr.markForCheck();
        });
    }

    protected isDeadlineOverdue(): boolean {
        return this.task.IsDeadlinePassed && this.isCurrentTasksView();
    }

    protected isCompletedView(): boolean {
        return this.viewMode === FiTasksViewMode.completed;
    }

    protected openTaskDetails(): void {
        this.fiStateService.go(FiStateNames.TaskV2.Details, { id: this.task.Id });
    }

    protected onStatusChange(newStatus: FiTaskStatusType): void {
        this.fiTaskV2HelperService.emitTaskStatusChange(this.task, newStatus);
    }

    protected isDescriptionContainerVisible(): boolean {
        return !!this.task.Description?.length || !!this.task.MediaBankFileReferences?.length || this.isAutomatedTask();
    }

    protected isAutomatedTask(): boolean {
        return this.task.TaskType === FiTaskType.ChecklistAutomated;
    }

    private isCurrentTasksView(): boolean {
        return this.viewMode === FiTasksViewMode.notCompleted;
    }

    private ngOnDestroy$ = new Subject<void>();
    public ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
